<template>
  <div>
    <div class="tools-bar">
      <el-row>
        <el-col :span="18">
          <span>已选择: {{ multipleSelection.length }}条</span>
          <el-button
            size="small"
            @click="onClickDelBtn(multipleSelection.map(item => item.memberCode))"
            >删除</el-button
          >
        </el-col>
        <el-col :span="6">
          <el-form :inline="true" :model="searchForm" size="mini">
            <el-form-item label="">
              <el-input v-model="searchForm.searchKey" placeholder="关键词" size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearchFormSubmit" size="mini">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <el-table :data="members" size="mini" @selection-change="handleSelectionChange" border>
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="memberCode" label="编号"></el-table-column>
      <el-table-column prop="memberName" label="名字"></el-table-column>
      <el-table-column width="50" label="操作">
        <template slot-scope="scope">
          <el-button @click="onClickDelBtn([scope.row.memberCode])" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      hide-on-single-page
      :total="total"
      :current-page="pageNum"
      :page-size="pageSize"
      @current-change="onPageNumChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import {getMembersByNode, delMembersFromNode} from '../../apis';

export default {
  name: 'MembersTable',
  components: {},
  props: {
    groupCode: {
      type: String,
      required: true
    },
    nodeCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      members: [],
      multipleSelection: [],
      searchForm: {
        searchKey: ''
      }
    };
  },
  watch: {
    nodeCode() {
      this.$_resetSearchCond();
      this.getData();
    }
  },
  async mounted() {},
  methods: {
    $_resetSearchCond() {
      this.pageNum = 1;
      this.multipleSelection = [];
      this.searchForm = {searchKey: ''};
      this.attrs = [];
    },
    onSearchFormSubmit() {
      this.pageNum = 1;
      this.multipleSelection = [];
      this.getData();
    },
    onPageNumChange(pageNum = 1) {
      this.pageNum = pageNum;
      this.getData();
    },
    async getData() {
      if (!this.nodeCode) {
        this.$message.warning('请选择一个节点');
        return;
      }
      let res = await getMembersByNode(
        this.groupCode,
        this.nodeCode,
        this.searchForm.searchKey,
        this.pageNum,
        this.pageSize
      );
      this.members = res.list;
      this.total = res.total;
    },
    handleSelectionChange(val = []) {
      this.multipleSelection = val;
    },
    async onClickDelBtn(memberCodes = []) {
      if (memberCodes.length === 0) {
        this.$message.warning('请选择一条记录');
        return;
      }
      await delMembersFromNode(this.groupCode, this.nodeCode, memberCodes);
      this.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
.tools-bar {
  margin-bottom: 10px;
}
</style>
